const ONE_KB = 1024;
const ONE_MEGABIT = ONE_KB * ONE_KB;
export const Size = {
  ONE_KB,
  ONE_MEGABIT,
  ONE_MB: ONE_MEGABIT,
  FIVE_MBPS: 5 * ONE_MEGABIT,
  EIGHT_MBPS: 8 * ONE_MEGABIT,
  FORTY_FIVE_MBPS: 45 * ONE_MEGABIT,
  ONE_TWENTY_EIGHT_KBPS: 128 * ONE_KB,
} as const;
